// extracted by mini-css-extract-plugin
export default {"root":"c7Qw_pJASpbTG47v8gTK","btn":"H3dKl7q3pBCoXdZG2wAg"};